import React from "react";
import PropTypes from "prop-types";

const Label = ({ value, target }) => (
  <label
    className="block mb-2 text-grey-darker-1 font-medium text-12 uppercase"
    htmlFor={target}
  >
    {value}
  </label>
);

Label.propTypes = {
  value: PropTypes.string,
  target: PropTypes.string
};

export default Label;
